// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4838":"fecd3c8b","5938":"fecd3c8b"}[chunkId] + ".chunk.css";
};